﻿import React from "react";
import {
  Typography,
  TextField,
  Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditCatalogData,
  selectIsEditMode,
  setCatalogDataField,
} from "@/features/connections/manageCatalogDataSlice";
import {
  defaultCode,
  blankCode,
} from "@/features/connections/integrationSlice";
import { AddEditCatalogPopup } from "./CatalogPopup";

const AddWarehousePopup = ({ onClose, onValidate, onComplete }) => {
  const dispatch = useDispatch();
  const dataValues = useSelector(selectEditCatalogData);
  const isEdit = useSelector(selectIsEditMode);

  const validateForm = () => {
    if (onValidate) {
      const result = onValidate(dataValues);
      if (!result.isValid) return result;
    }
    if (dataValues.Code === defaultCode) {
      return {
        isValid: false,
        message: `Warehouse Code cannot be saved as ${defaultCode}`,
      };
    }
    if (dataValues.Code === blankCode) {
      return {
        isValid: false,
        message: `Warehouse Code cannot be saved as ${blankCode}`,
      };
    }
    if (dataValues.Code?.includes(",")) {
      return {
        isValid: false,
        message: `The Warehouse Code cannot include a ','`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    dispatch(setCatalogDataField({ name, value }));
  };
  return (
    <AddEditCatalogPopup
      onClose={handleClose}
      onValidate={validateForm}
      onComplete={onComplete}
    >
      <Grid item xs={4}>
        <Typography>Warehouse Code </Typography>
        <Typography>
          <TextField
            disabled={isEdit}
            variant="outlined"
            name="Code"
            value={dataValues?.Code || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Name</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Name"
            value={dataValues?.Name || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={4}>
        <Typography sx={{ marginTop: "25px", marginBottom: "15px" }}>
          Warehouse Details
        </Typography>
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={4} />
      <Grid item xs={4}>
        <Typography>Warehouse Address 1</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Address1"
            value={dataValues?.Address1 || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Address 2</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Address2"
            value={dataValues?.Address2 || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse City</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="City"
            value={dataValues?.City || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse State</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="State"
            value={dataValues?.State || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse ZIP Code</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="PostalCode"
            value={dataValues?.PostalCode || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Country</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Country"
            value={dataValues?.Country || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Contact Name</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Contact"
            value={dataValues?.Contact || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Phone</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Phone"
            value={dataValues?.Phone || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Fax</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Fax"
            value={dataValues?.Fax || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Warehouse Email</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="Email"
            value={dataValues?.Email || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={4} />
    </AddEditCatalogPopup>
  );
};

export default AddWarehousePopup;
